import { createSelector } from '@reduxjs/toolkit';

import { LANGUAGES_MAP } from '@/constants/internationalization';

import languageSelector from './language';

const mapsLanguageSelector = createSelector(
  languageSelector,
  language => LANGUAGES_MAP[language],
);

export default mapsLanguageSelector;
